"use strict";

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (angular) {
  "use strict";

  angular.module("fleetviewApp").component("complianceRouteDetails", {
    template: require("./compliance-routedetail.component.html"),
    controller: complianceRouteDetailsController
  });

  complianceRouteDetailsController.$inject = ["$scope", "$location", "LayoutService", "complianceMapService", "complianceService", "$stateParams", "$state", "RoutingProfiles", "mapUtilities", "$q", "UserProvider", "ComplianceRoutingProfileService", "cacheService", "timeService"];

  function complianceRouteDetailsController($scope, $location, LayoutService, complianceMapService, complianceService, $stateParams, $state, RoutingProfiles, mapUtilities, $q, UserProvider, ComplianceRoutingProfileService, cacheService, timeService) {
    var vm = this;
    vm.settings = $stateParams.settings;
    if (!vm.settings || _.isEmpty(vm.settings)) {
      vm.settings = cacheService.getSearchSettings();
    }
    vm.currentState = $stateParams.currentState;
    vm.$onInit = init;
    vm.$onDestroy = destroy;
    vm.leftPanelWidth = leftPanelWidth;
    vm.selectRoute = selectRoute;
    vm.frameRoute = frameRoute;
    vm.setRouteVisibility = setRouteVisibility;
    vm.setRoutePingsVisibility = setRoutePingsVisibility;
    vm.changeProfile = complianceService.changeProfile;
    vm.zoomtoStop = zoomtoStop;
    vm.currentPageNum = $stateParams.pageNumber;
    vm.currentPageIndex = $stateParams.pageIndex;
    vm.totalPagesNum = $stateParams.totalPagesNum;
    vm.nextRoute = nextRoute;
    vm.prevRoute = prevRoute;
    vm.getCurrentRouteIndex = getCurrentRouteIndex;
    vm.backToRoutes = backToRoutes;

    // stores the routes in the current page, which helps to synchronize with the view
    vm.routeList = [];

    vm.routesPerPage = 10;

    vm.selectedRouteId = 0;

    vm.isLoading = true;

    function init() {
      complianceMapService.initMap();
      // draw all routes first, and then hide the ones that we want to hide.
      complianceService.initRoutes(vm, vm.settings, vm.currentPageNum, vm.currentPageIndex).then(function () {
        vm.route = vm.routeList[vm.currentPageIndex];
        var routeVisibilityList = complianceService.getRouteVisibilityList();
        var routeIndex = vm.getCurrentRouteIndex();
        vm.selectRoute(routeVisibilityList[routeIndex].tripId, routeVisibilityList[routeIndex].isVisible);
      });
    }

    function getCurrentRouteIndex() {
      return (vm.currentPageNum - 1) * vm.routesPerPage + vm.currentPageIndex;
    }

    function nextRoute() {
      vm.currentPageIndex++;
      if (vm.currentPageIndex >= vm.routeList.length) {
        vm.currentPageNum++;
        vm.currentPageIndex = 0;
      }

      // draw all routes first, and then hide the ones that should be invisible.
      complianceService.initRoutes(vm, vm.settings, vm.currentPageNum, vm.currentPageIndex).then(function () {
        vm.route = vm.routeList[vm.currentPageIndex];
        var routeIndex = vm.getCurrentRouteIndex();
        var routeVisibilityList = complianceService.getRouteVisibilityList();
        vm.selectRoute(routeVisibilityList[routeIndex].tripId, routeVisibilityList[routeIndex].isVisible);
      });
    }

    function backToRoutes() {
      $state.go($stateParams.parentState, {
        queryUrl: $stateParams.queryUrl,
        pageNumber: vm.currentPageNum
      });
    }

    function prevRoute() {
      vm.currentPageIndex--;
      if (vm.currentPageIndex < 0) {
        vm.currentPageNum--;
        vm.currentPageIndex = 9;
      }

      // draw all routes first, and then hide the ones that should be invisible.
      complianceService.initRoutes(vm, vm.settings, vm.currentPageNum, vm.currentPageIndex).then(function () {
        vm.route = vm.routeList[vm.currentPageIndex];
        var routeIndex = vm.getCurrentRouteIndex();
        var routeVisibilityList = complianceService.getRouteVisibilityList();
        vm.selectRoute(routeVisibilityList[routeIndex].tripId, routeVisibilityList[routeIndex].isVisible);
      });
    }

    function destroy() {
      complianceMapService.clearMap();
    }

    // when a user selects a particular route for the first time, 
    // set visibility for the route and GPS pings
    // and the visibility should persist until the user changes the settings
    function selectRoute(tripId, isVisible) {
      vm.selectedRouteId = tripId;

      vm.setRouteVisibility(tripId, isVisible);

      vm.setRoutePingsVisibility(tripId, isVisible);
    }

    function setRouteVisibility(tripId, isVisible) {
      // set the route in the view to visible
      var idx = vm.routeList.map(function (r) {
        return r.tripId;
      }).indexOf(tripId);
      vm.routeList[idx].isVisible = isVisible;

      // update our route visibility array in complianceService
      var index = complianceService.getRouteVisibilityList().map(function (r) {
        return r.tripId;
      }).indexOf(tripId);
      complianceService.setRouteVisibility(index, isVisible);

      // set the route visibility in the map
      complianceMapService.setRouteVisibility(tripId, isVisible);
    }

    function setRoutePingsVisibility(tripId, routePingsVisible) {
      // set the route pings visibility in the view
      var idx = vm.routeList.map(function (r) {
        return r.tripId;
      }).indexOf(tripId);
      vm.routeList[idx].isRoutePingsVisible = routePingsVisible;

      complianceMapService.setRoutePingsVisibility(tripId, routePingsVisible);
    }

    function frameRoute(tripId) {
      complianceMapService.frameRoute(tripId);
    }

    function zoomtoStop(latlong) {
      complianceMapService.zoomtoStop(latlong);
    }

    function leftPanelWidth() {
      return LayoutService.getLeftPanelWidth();
    }

    // todo: put into common file
    function _isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
  }
})(window.angular);


// WEBPACK FOOTER //
// ./app/compliance/compliance-routedetail.component.js